import React, { useRef, useMemo } from 'react'
import Edit from './index'

export default ({ onSubmit, title }) => {
  const modalRef = useRef()

  const open = (defs, rowData) => {
    if (modalRef.current) {
      modalRef.current.open(defs, rowData)
    }
  }

  const close = () => {
    if (modalRef.current) {
      modalRef.current.close()
    }
  }

  const DittoInlineModalRender = useMemo(() => {
    return <Edit ref={modalRef} onSubmit={onSubmit} title={title} />
  }, [onSubmit, modalRef])

  return {
    open,
    close,
    DittoInlineModalRender,
  }
}
